// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Loader_wrapper__3hasz","spinner":"Loader_spinner__1BGHY","spin":"Loader_spin__1X-nh"};